<template>
	<div class="gb-photoalbum-content-schedule">
		<v-layout class="gb-photoalbum-content-schedule-layout ma-2 pa-0" align-center justify-end column fill-height>
			<v-toolbar flat color="white">
				<v-toolbar-title>{{contentTitle}}</v-toolbar-title>
			</v-toolbar>
			<v-data-table
				:headers="contentHeaders"
				:items="items"
				:expand="false"
				item-key="schedule_id"
				hide-actions
				class="elevation-1 photo-table"
			>
					<template v-slot:items="props">
						<tr @click="onClickTableRow(props)">
							<td class="name pa-0">
								<GBPhotoAlbumItemNotReference v-if="!props.item.reference" />
								<div class="px-4">
									{{ props.item.name }}
								</div>
							</td>
							<td class="schedule_title">{{ props.item.schedule_title }}</td>
							<td>{{ props.item.schedule_begin }}～{{ props.item.schedule_end }}</td>
							<td>{{ props.item.last_modified_at }}</td>
							<td style="text-align: right;">{{ props.item.progress_rate }}</td>
							<td class="justify-center layout px-0 cursor-pointer" @click.stop="onDisplayMenu(props)">
								<v-icon small>menu</v-icon>
							</td>
						</tr>
					</template>
					<template v-slot:expand="props">
						<v-layout align-center justify-end row fill-height>
							<v-btn v-if="!download_album" flat small color="primary" @click="onDownloadAlbum(props)">アルバムをダウンロード</v-btn>
							<v-btn v-else flat color="primary" class="disabled" disabled>
								<v-progress-circular
									indeterminate
									color="primary"
								></v-progress-circular>
							</v-btn>
						</v-layout>
					</template>
					<template v-slot:no-data>
						{{noDataText}}
					</template>
			</v-data-table>
		</v-layout>
	</div>
</template>
<script>
import GBPhotoAlbumItemNotReference from './GBPhotoAlbumItemNotReference';
import {DISPLAY_LIST_TYPE} from '../../data/Const';

export default {
	name: 'GBPhotoAlbumContentSchedule',
	props: [ 'items', 'download_album', 'select_id', 'display_list_type' ],
	data (){
		return{
			project_headers: [
				{ text: 'メンバー', align: 'left', sortable: false, value: 'member_name' },
				{ text: '件名', align: 'left', sortable: false, value: 'title' },
				{ text: 'スケジュール', align: 'left', sortable: false, value: 'member_schedule' },
				{ text: '写真更新日時', align: 'left', sortable: false, value: 'photo_upd_at' },
				{ text: '進捗率(%)', align: 'left', sortable: false, value: 'progress_rate' },
				{ text: '設定', align: 'center', sortable: false, value: 'setting' },
			],
			member_headers: [
				{ text: '案件', align: 'left', sortable: false, value: 'member_name' },
				{ text: '件名', align: 'left', sortable: false, value: 'title' },
				{ text: 'スケジュール', align: 'left', sortable: false, value: 'member_schedule' },
				{ text: '写真更新日時', align: 'left', sortable: false, value: 'photo_upd_at' },
				{ text: '進捗率(%)', align: 'left', sortable: false, value: 'progress_rate' },
				{ text: '設定', align: 'center', sortable: false, value: 'setting' },
			],
		}
	},
	components: {
		GBPhotoAlbumItemNotReference,
	},
	methods: {
		onClickTableRow: function(props) {
			this.$emit('click-schedule', props.item);
		},
		onDisplayMenu: function(props) {
			props.expanded = !props.expanded
		},
		onDownloadAlbum: function(props) {
			props.expanded = !props.expanded
			this.$emit('download-shedule-album', props.item);
		},
	},
	computed: {
		contentTitle: function() {
			let ret = ''
			if (this.display_list_type == DISPLAY_LIST_TYPE.PROJECT) {
				ret = 'メンバー';
			} else {
				ret = '案件';
			}
			return ret;
		},
		contentHeaders: function() {
			let ret = [];
			if (this.display_list_type == DISPLAY_LIST_TYPE.PROJECT) {
				ret = this.project_headers;
			} else {
				ret = this.member_headers;
			}
			return ret;
		},
		noDataText: function() {
			let ret = ''
			if (this.select_id) {
				ret = 'スケジュールが登録されていません';
			} else {
				if (this.display_list_type == DISPLAY_LIST_TYPE.PROJECT) {
					ret = '案件を選択してください';
				} else {
					ret = 'メンバーを選択してください';
				}
			}
			return ret;
		},
	},
};

</script>
<style>
	.gb-photoalbum-content-schedule {
		position: relative;
		border-top:solid 1px #DFDFDF;
		width: 100%;
		background-color: #fefefe;
	}
	.gb-photoalbum-content-schedule .gb-photoalbum-content-schedule-layout {
		position: relative;
	}
	.gb-photoalbum-content-schedule .gb-photoalbum-content-schedule-layout .photo-table {
		width: 100%;
	}
	.gb-photoalbum-content-schedule .photo-table .name {
		width: 20%;
	}
	.gb-photoalbum-content-schedule .photo-table .schedule_title {
		width: 20%;
	}
</style>
